import { ReplaySubject } from "rxjs";

export interface ChatMessage {
  history?: boolean;
  unread?: boolean;
  read?: boolean;
  delivered?: boolean;
  messageId?: string;
  timestamp?: number;
  pm?: string;
  gm?: string;
  senderId?: string;
  senderName?: string;
  status?: number
  content?: string;
  channel?: string;
  helpDeskEvent?: number;
  helpDeskTicketId?: number;
  localId?: string;
  fromServer?: boolean;
  imageName?: string;
  imageData?: string;
  isPdf?: boolean;
  qp?: number;
}

export interface ChatMessageDisplay {
  messageId: number;
  isLocalOnly: boolean;
  from: string;
  localId: string
  dateDisplay: string;
  content: string;
  hasSent: boolean;
  hasDelivered: boolean;
  hasRead: boolean;
  isMine: boolean;
  inQueue: boolean;
  isImage: boolean;
  imageName: string;
  imageData?: ReplaySubject<string>;
  imageUrl: string;
  isPdf?: boolean;
  sysMsgType?: SystemMessageType;
  chatRole?: ChatRole;
}

export enum SystemMessageType {
  SYSTEM_THANKS = "QUEUE_THANKS",
  SYSTEM_END_CHAT = "QUEUE_END_CHAT",
  SYSTEM_JOINED_CHAT = "QUEUE_JOINED_CHAT",
  SYSTEM_ROUTED_CHAT = 'QUEUE_ROUTED_CHAT'
}

export enum ChatRole {
  CUSTOMER = "CUSTOMER",
  EMPLOYEE = "EMPLOYEE",
  SYSTEM = "SYSTEM",
}